import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contractstatus',
  templateUrl: './contractstatus.component.html',
  styleUrls: ['./contractstatus.component.css']
})
export class ContractstatusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
